<template>
  <div :class="index < $store.state.carts.length -1 ? 'pb-4' : 'pb-2'">
    <v-card raised>
      <v-card-title class="pa-2">
        <v-layout align-center="">
          <v-layout 
            :align-center="$vuetify.breakpoint.smAndUp" 
            wrap>
            <v-flex 
              xs12 
              sm5>
              <v-layout>
                <v-layout column>
                  <span>
                    {{ item.account_name }}
                  </span>
                  <span>
                    <strong>
                      {{ item.name }}
                    </strong>
                  </span>
                </v-layout>
                <v-btn 
                  v-if="$vuetify.breakpoint.xsOnly" 
                  class="ma-0" 
                  icon 
                  @click="remove">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex 
              xs12 
              sm5>
              <v-text-field 
                ref="code" 
                v-model="item.code" 
                :box="$vuetify.breakpoint.smAndUp" 
                hide-details 
                label="Seurantakoodi" 
                @focus="focus" 
                @blur="$store.state.qtyfocus = false" 
                @keyup.native.enter="blur" />
            </v-flex>
          </v-layout>
          <v-btn 
            v-if="$vuetify.breakpoint.smAndUp" 
            icon 
            @click="remove">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-divider/>
      <cart :index="index" />
      <product-list :index="index" />
    </v-card>
    <v-dialog 
      v-model="dialog" 
      width="300">
      <v-card>
        <v-card-title class="title">
          Poista kohde?
        </v-card-title>
        <v-divider/>
        <v-card-text>
          Oletko varma että haluat poistaa kohteen? Menetät kaikki kohteessa olevat varaukset.
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn 
            flat 
            @click="dialog = false">Peruuta</v-btn>
          <v-btn 
            flat 
            color="error" 
            @click="confirm">Poista</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
	props: ['item', 'index'],
	data() {
		return {
			dialog: false
		}
	},
	methods: {
		blur() {
			this.$refs.code.blur()
		},
		focus() {
			if (navigator.maxTouchPoints > 0) {
				this.$store.state.qtyfocus = true
			}
		},
		remove() {
			if (this.$store.state.carts[this.index].products.length > 0) {
				this.dialog = true
			} else this.$store.commit('removeCart', {index: this.index, item: this.item})
		},
		confirm() {
			this.$store.commit('removeCart', {index: this.index, item: this.item})
			this.dialog = false
		}
	}
}
</script>
